import { render, staticRenderFns } from "./IntegrasiMarketplacePage.vue?vue&type=template&id=2763cc6c&scoped=true&"
import script from "./IntegrasiMarketplacePage.vue?vue&type=script&lang=js&"
export * from "./IntegrasiMarketplacePage.vue?vue&type=script&lang=js&"
import style0 from "./IntegrasiMarketplacePage.vue?vue&type=style&index=0&id=2763cc6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2763cc6c",
  null
  
)

export default component.exports